import ColumnDefinition from '../ColumnDefinition.js';
import ContextMenuDefinition from '../ContextMenuDefinition.js';

export default {
    defaultSort: { field: 'created_at', direction: 'desc' },
    columns: [
        new ColumnDefinition('file_name', window.i18n.__('Document'), false, false, function (fileName, row) {
            return {
                type: 'component',
                name: 'cell-link',
                params: {
                    label: fileName,
                    event: 'ocr:verify',
                    eventParams: { id: row.id },
                    dataBot: 'purchases-purinvoices-list_verify-invoice_click',
                },
            };
        }),
        new ColumnDefinition('created_at', window.i18n.__('Date d’entrée'), false, true, function (date) {
            return window.sellsyapp.config.globalProperties.$filters.dateFormatter(
                date,
                'SLASHED_DATE_TIME',
            );
        }),
        new ColumnDefinition('source', window.i18n.__('Source'), false, true, function (source) {
            const sourceConfig = {
                facturx: {
                    label: 'Électronique',
                    color: 'blue',
                    icon: 'email',
                },
                default: {
                    label: 'Importée',
                    color: 'light-blue',
                    icon: 'upload',
                },
            };

            const config = sourceConfig[source] || sourceConfig.default;

            const pillProps = {
                variant: 'pastel',
                size: 'small',
                label: window.i18n.__(config.label),
                color: config.color,
                icon: config.icon,
            };

            return {
                type: 'component',
                name: 'cell-wrapper',
                params: {
                    componentName: 'compass-pill',
                    componentProps: pillProps,
                },
            };
        }),
        new ColumnDefinition('state', window.i18n.__('Statut'), false, false, function (state, row) {
            return {
                type: 'component',
                name: 'ocr-item-state',
                params: {
                    state,
                    id: row.id,
                    errorCode: row.error_code,
                    isElectronicDoc: row.source === 'facturx',
                },
            };
        }),
    ],
    filters: [],
    hooks: {
        metas: function (metas) {
            return metas;
        },
        fetch: function (data) {
            data.filters.state = ['completed', 'error', 'pending', 'processing'];
        },
    },
    contextMenus: [
        new ContextMenuDefinition(
            'verify',
            window.i18n.__('Vérifier'),
            function (row) {
                return {
                    event: 'ocr:verify',
                    params: { id: row.id },
                };
            },
            'vuejs',
            '_parent',
            function (row) {
                if (!this.metas.user_can_validate_pur_invoice) {
                    return true;
                }
                return ['processing', 'pending'].includes(row.state);
            },
            'purchases-purinvoices-list_verify-invoice_row'
        ),
        new ContextMenuDefinition(
            'delete',
            window.i18n.__('Supprimer'),
            function (row) {
                return {
                    event: 'ocr:delete',
                    params: { id: row.id },
                };
            },
            'vuejs',
            '_parent',
            function (row) {
                if (row.source === 'facturx') {
                    return true;
                }
                return !this.metas.user_can_validate_pur_invoice;
            },
            'purchases-purinvoices-list_delete-invoice_row'
        ),
    ],
    batchActions: [],
};
